module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/022-syria-e8cc5e649ecae85ed8f27960f41ad28f.svg";